export default "__VITE_ASSET__qHEK55eU__"